<label class="drawer-label" [for]="labelID" *ngIf="labelID">{{ label }}</label>
<div class="color-field-wrapper">
  <div class="field color">
    <input
      type="color"
      [id]="labelID"
      [name]="labelID"
      [value]="initialColor"
    />
  </div>
  <div
    class="field"
    i18n-tooltip="@@Color opacity (0 - 100)"
    tooltip="Color opacity (0 - 100)"
    placement="top"
  >
    <input type="text" [value]="opacity" />
  </div>
  <div class="suffix">%</div>
</div>
